class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) collection.classList.add('loading');
    }
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderActiveFacets(html);
        FacetFiltersForm.renderSortOptions(html);
        FacetFiltersForm.renderPagination(html);
      });
  }

  static renderSortOptions(html) {
    const parsedHTML = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
    
    // Get sort options from fetched HTML
    const newSortOptions = parsedHTML.querySelectorAll('#FacetFiltersForm .facets__display--sort input[type="radio"]');
    const currentSortOptions = document.querySelectorAll('#FacetFiltersForm .facets__display--sort input[type="radio"]');
    
    if (newSortOptions.length > 0 && currentSortOptions.length > 0) {
      // Update checked state for each option
      newSortOptions.forEach((newOption, index) => {
        if (currentSortOptions[index]) {
          currentSortOptions[index].checked = newOption.checked;
          
          // Update active class on label
          const currentLabel = currentSortOptions[index].closest('.facet-radio');
          if (currentLabel) {
            if (newOption.checked) {
              currentLabel.classList.add('active');
            } else {
              currentLabel.classList.remove('active');
            }
          }
        }
      });
    }
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderActiveFacets(html);
    FacetFiltersForm.renderSortOptions(html);
    FacetFiltersForm.renderPagination(html);
  }

  static renderProductGridContainer(html) {
    const newDoc = new DOMParser().parseFromString(html, 'text/html');
    const newContainer = newDoc.getElementById('ProductGridContainer');
    const currentContainer = document.getElementById('ProductGridContainer');
    
    if (newContainer && currentContainer) {
      currentContainer.innerHTML = newContainer.innerHTML;
      
      // Check if there are products
      const collection = currentContainer.querySelector('#collection');
      const products = collection ? collection.querySelectorAll('.halo-column__item') : [];
      const noProductsMessage = document.getElementById('NoProductsMessage');
      const paginationContainer = document.getElementById('product-collection--infini');
      
      if (products.length === 0) {
        // No products found - show empty state
        if (noProductsMessage) {
          noProductsMessage.style.display = 'block';
        }
        if (currentContainer) {
          currentContainer.style.display = 'none';
        }
        if (paginationContainer) {
          paginationContainer.style.display = 'none';
        }
      } else {
        // Products found - show grid
        if (noProductsMessage) {
          noProductsMessage.style.display = 'none';
        }
        if (currentContainer) {
          currentContainer.style.display = 'block';
        }
        if (paginationContainer) {
          paginationContainer.style.display = 'block';
        }
      }
    }
  }

  static renderPagination(html) {
    const parsedHTML = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
    
    // Get pagination from fetched HTML
    const newPagination = parsedHTML.getElementById('product-collection--infini');
    const currentPagination = document.getElementById('product-collection--infini');
    
    if (newPagination && currentPagination) {
      currentPagination.innerHTML = newPagination.innerHTML;
    }
  }
  static renderProductCount(html) {
    const newDoc = new DOMParser().parseFromString(html, 'text/html');
    const newCount = newDoc.getElementById('ProductCount');
    const newCountDesktop = newDoc.getElementById('ProductCountDesktop');
    
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (newCount && container) {
      container.innerHTML = newCount.innerHTML;
      container.classList.remove('loading');
    }
    
    if (newCountDesktop && containerDesktop) {
      containerDesktop.innerHTML = newCountDesktop.innerHTML;
      containerDesktop.classList.remove('loading');
    }
    
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const targetParent = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
          if (targetParent) {
            targetParent.before(elementToRender);
          }
        }
      }
    });

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement.querySelector('.facets__summary');

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const parsedHTML = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
    const activeFacetsElement = parsedHTML.querySelector('.active-facets-desktop');
    const currentActiveFacets = document.querySelector('.active-facets-desktop');
    
    if (activeFacetsElement && currentActiveFacets) {
      currentActiveFacets.innerHTML = activeFacetsElement.innerHTML;
    }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('collection');
    const searchGrid = document.querySelector('.page-search');
    
    if (searchGrid) {
      // For search page
      return [
        {
          section: searchGrid.dataset.sectionId,
        },
      ];
    }
    
    // For collection page
    return [
      {
        section: productGrid ? productGrid.dataset.id : document.querySelector('[data-section-id]').dataset.sectionId,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];

    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm') {
        forms.push(this.createSearchParams(form));
      }
    });
    
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    
    const desktopForm = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    const mobileForm = this.closest('facet-filters-form-mobile') || document.querySelector('facet-filters-form-mobile');
    
    const isMobile = this.closest('.mobile-facets__toolbar') || 
                     this.closest('.mobile-facets__wrapper') || 
                     this.closest('.active-facets-mobile') ||
                     this.closest('.active-facets-mobile-outside') || 
                     this.closest('.no-products-message'); 
    
    if (isMobile && mobileForm) {
      mobileForm.onActiveFilterClick(event);
    } else if (desktopForm) {
      desktopForm.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);

// Utility function for debouncing
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Utility function for escape key
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Close dropdowns when clicking outside
document.addEventListener('click', function(event) {
  // Desktop: Close filter and sort dropdowns
  const openDetails = document.querySelectorAll('facet-filters-form details[open]');
  openDetails.forEach(details => {
    if (!details.contains(event.target)) {
      details.removeAttribute('open');
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  });
  
  // Mobile: Close sort dropdown
  const mobileSortWrapper = document.querySelector('.mobile-facets__sort-wrapper[open]');
  if (mobileSortWrapper && !mobileSortWrapper.contains(event.target)) {
    mobileSortWrapper.removeAttribute('open');
  }
});

// Prevent closing when clicking inside the dropdown
document.addEventListener('click', function(event) {
  if (event.target.closest('.facets__display') || 
      event.target.closest('.mobile-facets__sort-dropdown')) {
    event.stopPropagation();
  }
}, true);

// Sticky Filter Functionality - Updated for separate desktop/mobile
class StickyFilter {
  constructor() {
    this.initDesktop();
    this.initMobile();
  }
  
  initDesktop() {
    this.desktopFilter = document.querySelector('facet-filters-form.facets-wrapper--sticky[data-sticky-filter="desktop"]');
    if (!this.desktopFilter) return;
    
    this.header = document.querySelector('.site-header.header-sticky');
    this.headerHeight = this.header ? this.header.offsetHeight : 0;
    this.desktopPlaceholder = null;
    this.desktopIsSticky = false;
    this.desktopOriginalTop = 0;
    this.desktopTicking = false;
    
    this.createDesktopPlaceholder();
    
    requestAnimationFrame(() => {
      this.desktopOriginalTop = this.getDesktopOriginalTop();
      window.addEventListener('scroll', this.onDesktopScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.handleDesktopResize.bind(this), { passive: true });
      this.handleDesktopScroll();
    });
  }
  
  initMobile() {
    this.mobileToolbar = document.querySelector('.mobile-facets__toolbar-inner.facets-wrapper--sticky[data-sticky-filter="mobile"]');
    if (!this.mobileToolbar) return;
    
    this.header = this.header || document.querySelector('.site-header.header-sticky');
    this.headerHeight = this.header ? this.header.offsetHeight : 0;
    this.mobilePlaceholder = null;
    this.mobileIsSticky = false;
    this.mobileOriginalTop = 0;
    this.mobileTicking = false;
    
    this.createMobilePlaceholder();
    
    requestAnimationFrame(() => {
      this.mobileOriginalTop = this.getMobileOriginalTop();
      window.addEventListener('scroll', this.onMobileScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.handleMobileResize.bind(this), { passive: true });
      this.handleMobileScroll();
    });
  }
  
  // Desktop methods
  getDesktopOriginalTop() {
    if (this.desktopIsSticky) {
      return this.desktopPlaceholder.getBoundingClientRect().top + window.scrollY;
    }
    return this.desktopFilter.getBoundingClientRect().top + window.scrollY;
  }
  
  createDesktopPlaceholder() {
    this.desktopPlaceholder = document.createElement('div');
    this.desktopPlaceholder.className = 'facets-sticky-placeholder facets-sticky-placeholder--desktop';
    this.desktopFilter.parentNode.insertBefore(this.desktopPlaceholder, this.desktopFilter.nextSibling);
  }
  
  onDesktopScroll() {
    // Only run on desktop
    if (window.innerWidth < 990) return;
    
    if (!this.desktopTicking) {
      requestAnimationFrame(() => {
        this.handleDesktopScroll();
        this.desktopTicking = false;
      });
      this.desktopTicking = true;
    }
  }
  
  handleDesktopScroll() {
    if (window.innerWidth < 990) return;
    
    if (this.header) {
      this.headerHeight = this.header.offsetHeight;
    }
    
    const scrollTop = window.scrollY;
    const stickyTrigger = this.desktopOriginalTop - this.headerHeight;
    
    if (!this.desktopIsSticky && scrollTop >= stickyTrigger) {
      this.makeDesktopSticky();
    } else if (this.desktopIsSticky && scrollTop < stickyTrigger - 2) {
      this.removeDesktopSticky();
    }
  }
  
  handleDesktopResize() {
    if (this.header) {
      this.headerHeight = this.header.offsetHeight;
      if (this.desktopIsSticky) {
        this.desktopFilter.style.top = `${this.headerHeight}px`;
      }
    }
    
    if (!this.desktopIsSticky) {
      this.desktopOriginalTop = this.getDesktopOriginalTop();
    }
    
    if (this.desktopIsSticky) {
      this.desktopPlaceholder.style.height = `${this.desktopFilter.offsetHeight}px`;
    }
  }
  
  makeDesktopSticky() {
    if (this.desktopIsSticky) return;
    
    const filterHeight = this.desktopFilter.offsetHeight;
    this.desktopPlaceholder.style.height = `${filterHeight}px`;
    this.desktopPlaceholder.classList.add('is-active');
    this.desktopFilter.classList.add('is-sticky');
    this.desktopFilter.style.top = `${this.headerHeight}px`;
    this.desktopIsSticky = true;
  }
  
  removeDesktopSticky() {
    if (!this.desktopIsSticky) return;
    
    this.desktopFilter.classList.remove('is-sticky');
    this.desktopFilter.style.top = '';
    this.desktopPlaceholder.style.height = '0';
    this.desktopPlaceholder.classList.remove('is-active');
    this.desktopIsSticky = false;
    
    requestAnimationFrame(() => {
      this.desktopOriginalTop = this.getDesktopOriginalTop();
    });
  }
  
  // Mobile methods
  getMobileOriginalTop() {
    if (this.mobileIsSticky) {
      return this.mobilePlaceholder.getBoundingClientRect().top + window.scrollY;
    }
    return this.mobileToolbar.getBoundingClientRect().top + window.scrollY;
  }
  
  createMobilePlaceholder() {
    this.mobilePlaceholder = document.createElement('div');
    this.mobilePlaceholder.className = 'facets-sticky-placeholder facets-sticky-placeholder--mobile';
    this.mobileToolbar.parentNode.insertBefore(this.mobilePlaceholder, this.mobileToolbar.nextSibling);
  }
  
  onMobileScroll() {
    // Only run on mobile
    if (window.innerWidth >= 990) return;
    
    if (!this.mobileTicking) {
      requestAnimationFrame(() => {
        this.handleMobileScroll();
        this.mobileTicking = false;
      });
      this.mobileTicking = true;
    }
  }
  
  handleMobileScroll() {
    if (window.innerWidth >= 990) return;
    
    if (this.header) {
      this.headerHeight = this.header.offsetHeight;
    }
    
    const scrollTop = window.scrollY;
    const stickyTrigger = this.mobileOriginalTop - this.headerHeight;
    
    if (!this.mobileIsSticky && scrollTop >= stickyTrigger) {
      this.makeMobileSticky();
    } else if (this.mobileIsSticky && scrollTop < stickyTrigger - 2) {
      this.removeMobileSticky();
    }
  }
  
  handleMobileResize() {
    if (this.header) {
      this.headerHeight = this.header.offsetHeight;
      if (this.mobileIsSticky) {
        this.mobileToolbar.style.top = `${this.headerHeight}px`;
      }
    }
    
    if (!this.mobileIsSticky) {
      this.mobileOriginalTop = this.getMobileOriginalTop();
    }
    
    if (this.mobileIsSticky) {
      this.mobilePlaceholder.style.height = `${this.mobileToolbar.offsetHeight}px`;
    }
  }
  
  makeMobileSticky() {
    if (this.mobileIsSticky) return;
    
    const toolbarHeight = this.mobileToolbar.offsetHeight;
    this.mobilePlaceholder.style.height = `${toolbarHeight}px`;
    this.mobilePlaceholder.classList.add('is-active');
    this.mobileToolbar.classList.add('is-sticky');
    this.mobileToolbar.style.top = `${this.headerHeight}px`;
    this.mobileIsSticky = true;
  }
  
  removeMobileSticky() {
    if (!this.mobileIsSticky) return;
    
    this.mobileToolbar.classList.remove('is-sticky');
    this.mobileToolbar.style.top = '';
    this.mobilePlaceholder.style.height = '0';
    this.mobilePlaceholder.classList.remove('is-active');
    this.mobileIsSticky = false;
    
    requestAnimationFrame(() => {
      this.mobileOriginalTop = this.getMobileOriginalTop();
    });
  }
}

// Initialize sticky filter when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const hasDesktopSticky = document.querySelector('[data-sticky-filter="desktop"]');
  const hasMobileSticky = document.querySelector('[data-sticky-filter="mobile"]');
  
  if (hasDesktopSticky || hasMobileSticky) {
    new StickyFilter();
  }
});